import type { ISubscribeBlockDataLayer } from '@/types/dataLayer'

export function pushToDataLayer(data: object) {
  // @ts-ignore
  window.dataLayer = window.dataLayer || []
  // @ts-ignore
  window.dataLayer.push(data)
}

export function pushSubscribeBlockDataLayer(data: ISubscribeBlockDataLayer) {
  pushToDataLayer({
    event: 'sign_up_form',
    page_type: 'investors',
    ...data
  })
}
